
import XHeader from 'vux/src/components/x-header/index.vue'

import { mapState } from 'vuex'
import SaafHeader from '../SaafHeader'
export default {
props: {
preventGoBack: {
type: Boolean,
default: false
},
},
data () {
return {
}
},
components: {
XHeader:XHeader,
SaafHeader:SaafHeader,
},
created(){
},
computed: {
...mapState({
deviceInfo: state => state.user.deviceInfo,
}),
},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {
_clickBack(){
this.$emit('clickBack')
}
}
}



// WEBPACK FOOTER //
// ./src/common/components/page/PageHeader.vue